import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldText from "../../fields3/generic/text/text"
import FieldString from "../../fields3/generic/string/string"

const baseConfig = [
    {
        fieldId     : 'name',
        type        : FieldType.STRING,
        label       : 'Entity name'
    },
    {
        fieldId     : 'nameFieldLabel',
        type        : FieldType.STRING,
        label       : 'Name field label',
        description : 'The name field must be present in the entity, and only the label can be modified'
    },
    {
        fieldId     : 'apiUpdateUrl',
        type        : FieldType.STRING,
        label       : 'URL to update entity',
        description : 'A POST API request will be sent to this URL when updating, with the updated parameters included'
    },
    {
        fieldId     : 'apiDeleteUrl',
        type        : FieldType.STRING,
        label       : 'URL to delete entity',
        description : 'A DELETE API request will be sent to this URL when deleting, with the item ID provided as a parameter'
    },
    {
        fieldId     : 'fieldsConfigString',
        type        : FieldType.TEXT,
        label       : 'Fields config'
    },
]

export default class ExternalEntityFields extends FieldsCollection {

    constructor() {
        super(baseConfig, EntityType.CUSTOM_ENTITY);
    }

    get name()                  { return this.get('name') as FieldString }
    get nameFieldLabel()        { return this.get('nameFieldLabel') as FieldString }
    get apiUpdateUrl()          { return this.get('apiUpdateUrl') as FieldString }
    get apiDeleteUrl()          { return this.get('apiDeleteUrl') as FieldString }
    get fieldsConfigString()    { return this.get('fieldsConfigString') as FieldText }
}
